import styled from 'styled-components';

const List = styled.ul`
    list-style: none;
    padding: 0;
`

export default List;